import * as React from 'react';

function IconFilter(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 18 18" fill="none" {...props}>
      <path
        d="M14.25 6.75a2.25 2.25 0 00-2.115 1.5H2.25a.75.75 0 000 1.5h9.885a2.25 2.25 0 102.115-3zm0 3a.75.75 0 110-1.5.75.75 0 010 1.5zM2.25 5.25h.885a2.25 2.25 0 004.23 0h8.385a.75.75 0 100-1.5H7.365a2.25 2.25 0 00-4.23 0H2.25a.75.75 0 100 1.5zm3-1.5a.75.75 0 110 1.5.75.75 0 010-1.5zM15.75 12.75h-5.385a2.25 2.25 0 00-4.23 0H2.25a.75.75 0 000 1.5h3.885a2.25 2.25 0 004.23 0h5.385a.75.75 0 100-1.5zm-7.5 1.5a.75.75 0 110-1.5.75.75 0 010 1.5z"
        fill="currentColor"
      />
    </svg>
  );
}

const MemoIconFilter = React.memo(IconFilter);
export default MemoIconFilter;
